import { createSlice } from "@reduxjs/toolkit";

const customerServiceSlice = createSlice({
  name: "customerService",
  initialState: {
    idTicket: null,
    ticketsInfo: null,
    tickets: [],
    ticketTypes: [],
    ticketSubTypes: [],
    ticketMessages: [],
    ticket: null,
  },
  reducers: {
    setIdTicket(state, { payload }) {
      state.idTicket = payload;
    },
    setDataFilterTickets(state, { payload }) {
      state.tickets = payload;
    },
    setDataFilterTicketsInfo(state, { payload }) {
      state.ticketsInfo = payload;
    },
    setTicketTypes(state, { payload }) {
      state.ticketTypes = payload;
    },
    setTicketSubTypes(state, { payload }) {
      state.ticketSubTypes = payload;
    },
    setTicketCreated(state, { payload }) {
      state.ticket = payload;
    },
    setTicketMessages(state, { payload }) {
      state.ticketMessages = payload;
    },
    setCleanTicket(state) {
      state.ticketMessages = [];
      state.ticket = null;
    },
  },
});

export const {
  setIdTicket,
  setDataFilterTickets,
  setDataFilterTicketsInfo,
  setTicketTypes,
  setTicketSubTypes,
  setTicketCreated,
  setTicketMessages,
  setCleanTicket,
} = customerServiceSlice.actions;

export default customerServiceSlice.reducer;
